<template>
  <div>
    <Header/>
    <Navigationzj :toptNavi="5"/>
    <div class="w1200">
        <div style=" margin:0;">
            <div class="main-content-header clearfix">
                <div class="bd">
                    <el-carousel :interval="5000" arrow="always" height="385px">
                        <el-carousel-item v-for="(item,index) in industryIinfoList.slice(0, 3)" :key="index">
                            <router-link :to="{path:'/InfoDetail',query:{ id:item.id }}" :title="item.title" target="_blank">
                                <img v-real-img="item.filename" src="../../assets/images/zwtp.jpg" :alt="item.title"  width="700px" height="385px">
                            </router-link>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="news-list">
                    <div class="news-title clearfix">
                        <h2 class="news-title-text">
                            <router-link :to="{path:'/IndustryList'}" target="_blank">行业资讯</router-link>
                        </h2>
                        <router-link :to="{path:'/IndustryList'}" class="news-title-more" target="_blank">更多>></router-link>
                    </div>
                    <ul>
                        <li class="news-li" v-for="(item,index) in industryIinfoList.slice(3, 6)" :key="index">
                            <span class="news-li-title">
                                <router-link :to="{path:'/InfoDetail',query:{ id:item.id }}" :title="item.title" target="_blank">{{ item.title }}</router-link>
                            </span>
                            <span class="news-li-content">{{ item.content | setText }}</span>
                            <span>
                                <i class="sprite-time"></i>
                                <span class="news-li-operate">{{ item.addtime }}</span>
                                <i class="sprite-eyes"></i>
                                <span class="news-li-operate">阅读量({{ item.hit }})</span>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="article-container-bg">
                <div class="module">
                    <div class="module-title">
                        <h2 class="module-title-text">
                            <span>产品知识</span>
                        </h2>
                    </div>
                    <div class="module-content clearfix">
                        <div v-for="(item, index) in productKnowList" :key="index" class="content-box content-box-withtop">
                            <div class="content-title clearfix">
                                <h3 class="content-title-text content-title-active">
                                    <router-link :to="{path:'/InfoList',query:{ productclassifyid:item.id }}" target="_blank">{{ item.title }}</router-link>
                                </h3>
                                <router-link :to="{path:'/InfoList',query:{ productclassifyid:item.id }}" class="content-title-more" target="_blank">更多>></router-link>
                            </div>
                            <div class="content-headline clearfix" v-for="(items,index) in item.children.slice(0, 1)" :key="index">
                                <router-link :to="{path:'/InfoDetail',query:{ id:items.id }}" :title="items.title" target="_blank">
                                    <img v-real-img="items.filename" src="../../assets/images/zwtp.jpg" :alt="items.title" class="content-img">
                                </router-link>
                                <span class="content-img-title">
                                    <router-link :to="{path:'/InfoDetail',query:{ id:items.id }}" :title="items.title" target="_blank">{{ items.title }}</router-link>
                                </span>
                                <span class="content-img-desc">{{ items.content | setText }}</span>
                            </div>
                            <div class="content-ul">
                                <ul>
                                    <li class="content-li" v-for="(items,index) in item.children.slice(1, 6)" :key="index">
                                        <span :class='["content-li-icon",index > 2 ? "icon-dark":""]'>{{ index + 1 }}</span>
                                        <span class="content-li-text">
                                            <router-link :to="{path:'/InfoDetail',query:{ id:items.id }}" :title="items.title" target="_blank">{{ items.title }}</router-link>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="module">
                    <div class="module-title">
                        <h2 class="module-title-text">
                            <span>资料下载</span>
                        </h2>
                    </div>
                    <div class="module-content clearfix">
                        <ul class="content-ul clearfix">
                            <li v-for="(item, index) in 12" :key="index" class="content-li content-li-secondary">
                                <span class="content-li-before"></span>
                                <span class="content-li-text">
                                    <a href="" target="_blank" title="手持式折射计使用注意事项、保管方法及应用">手持式折射计使用注意事项、保管方法及应用</a>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div> -->
                <div class="module">
                    <!-- <ul class="radio-ul">
                        <li>
                            <div :class='["radio-btn","js-tabcategory",showinfo === 1 ? "active":""]' @click="showClassifyThemeLabel(1)">分类</div>
                        </li>
                        <li>
                            <div :class='["radio-btn","js-tabcategory",showinfo === 2 ? "active":""]' @click="showClassifyThemeLabel(2)">主题</div>
                        </li>
                        <li>
                            <div :class='["radio-btn","js-tabcategory",showinfo === 3 ? "active":""]' @click="showClassifyThemeLabel(3)">标签</div>
                        </li>
                    </ul> -->
                    <ul v-if="showinfo === 1" class="panel-ul active js-cotcategory">
                        <li v-for="(item, index) in classifyList" :key="index">
                            <router-link :to="{path:'/InfoList',query:{ productclassifysid:item.id }}" target="_blank">{{ item.title }}</router-link>
                        </li>
                    </ul>
                    <ul v-if="(showinfo === 2)" class="panel-ul active js-cotcategory">
                        <li v-for="(item, index) in themeList" :key="index">
                            <router-link :to="{path:'/InfoList',query:{ themeid:item.id }}" target="_blank">{{ item.title }}</router-link>
                        </li>
                    </ul>
                    <ul v-if="(showinfo === 3)" class="panel-ul active js-cotcategory">
                        <li v-for="(item, index) in labelList" :key="index">
                            <router-link :to="{path:'/InfoList',query:{ labelid:item.id }}" target="_blank">{{ item.title }}</router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <Footer/>
  </div>
</template>
<script>

import api from '@/api/resources'
import Header from '@/components/Resources/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'

export default {
  name: 'Resources',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  filters: {
    // 去除标签
    setText (html) {
      let txt = document.createElement('div')
      txt.innerHTML = html
      let content = txt.innerText || txt.textContent
      txt = null
      return content
    }
  },
  data () {
    return {
      industryIinfoList: [],
      productKnowList: [],
      classifyList: [],
      themeList: [],
      labelList: [],
      showinfo: 1,
      qyloading: false
    }
  },
  mounted () {
    this.getIndustryIinfoList()
    this.getProductKnowList()
    this.getClassifyList()
    // this.getThemeList()
    // this.getLabelList()
  },
  methods: {
    // 获取行业咨询
    getIndustryIinfoList () {
      api.getIndustryInfo({limit: 6, moduleid: 1, order: 'order_num', sort: 'asc', state: 'home'}).then(res => {
        this.industryIinfoList = res.items
      })
    },
    // 获取产品知识
    getProductKnowList () {
      api.getProductKnow({limit: 12, moduleid: 4, order: 'order_num', sort: 'asc'}).then(res => {
        this.productKnowList = res.items
      })
    },
    // 获取分类
    getClassifyList () {
      api.getClassifyThemeLabel({limit: 10000, moduleid: 4, level: 2, order: 'order_num', sort: 'asc'}).then(res => {
        this.classifyList = res.items
      })
    },
    // 获取主题
    getThemeList () {
      api.getClassifyThemeLabel({limit: 35, moduleid: 2, order: 'order_num', sort: 'asc'}).then(res => {
        this.themeList = res.items
      })
    },
    // 获取标签
    getLabelList () {
      api.getClassifyThemeLabel({limit: 35, moduleid: 3, order: 'order_num', sort: 'asc'}).then(res => {
        this.labelList = res.items
      })
    },
    // 获取分类主题标签选项卡
    showClassifyThemeLabel (e) {
      this.showinfo = e
    }
  }
}
</script>
<style scoped>
a {
    text-decoration: none;
    color: #333;
}
.main-content-header {
    padding: 15px 0;
}
.main-content-header .bd {
    float: left;
    width: 700px;
}
.module {
    width: 1200px;
    margin: 10px auto;
    overflow: hidden;
}
.module .module-title {
    width: 100%;
    height: auto;
    padding: 0 10px;
    background: #f2f2f2;
    border: 1px solid #e6e6e6;
    overflow: hidden;
}
.module .module-title .module-title-text {
    margin: 0;
    font-size: 16px;
    color: #333333;
    text-align: left;
    line-height: 40px;
    letter-spacing: 1px;
    float: left;
}
.module .module-title .module-title-more {
    float: right;
    line-height: 40px;
    margin-right: 10px;
    font-size: 15px;
}
.module .module-content {
    width: 1178px;
    height: auto;
    padding: 10px;
    background: #ffffff;
    border: 1px solid #dfdfdf;
    margin-top: -1px;
    margin-bottom: 10px;
}
.radio-ul {
    width: 100px;
    background-color: #ffffff;
    float: left;
}
.radio-ul > li div {
    height: 40px;
    line-height: 40px;
    border-top: 1px solid #e6e6e6;
    border-left: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
    border-right: 1px solid #194485;
    text-align: center;
    cursor: pointer;
}
.radio-ul > li div.active {
    border-top: 1px solid #194485;
    border-left: 1px solid #194485;
    border-bottom: 1px solid #194485;
    border-right: 1px solid #ffffff;
}
.radio-ul > li + li div {
    border-top: 0;
}
.panel-ul {
    width: 1168px;
    background-color: #ffffff;
    float: left;
    /* border-top: 1px solid #194485;
    border-right: 1px solid #194485;
    border-bottom: 1px solid #194485; */
    border: 1px solid #dfdfdf;
    display: none;
    height: 122px;
    padding: 0.5px 15px;
    overflow-y: auto;
}
.panel-ul::-webkit-scrollbar {/*滚动条整体样式*/
    width: 5px;     /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
}
.panel-ul::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    border-radius: 10px;
    background: #c1c1c1;
}
.panel-ul::-webkit-scrollbar-track {/*滚动条里面轨道*/
    border-radius: 10px;
    background: #ededed;
}
.panel-ul.active {
    display: block;
}
.panel-ul > li {
    display: inline-block;
}
.panel-ul > li a {
    display: block;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
}
.panel-ul > li a:hover {
    color: #194485;
}
.main-content-header {
    padding: 15px 0;
}
.main-content-header .news-list {
    float: right;
    width: 484px;
    overflow: hidden;
}
.main-content-header .news-list i {
    display: inline-block;
    vertical-align: middle;
}
.main-content-header .news-list .news-title {
    background: #f2f2f2;
    border: 1px solid #e6e6e6;
    border-bottom: 0;
    width: 97%;
    height: 30px;
    padding: 0 10px;
}
.main-content-header .news-list .news-title .news-title-text {
    float: left;
    display: inline-block;
    height: 100%;
    margin: 0;
    line-height: 28px;
    font-size: 18px;
    color: #333333;
    letter-spacing: 1px;
    text-align: left;
    vertical-align: center;
}
.main-content-header .news-list .news-title .news-title-more {
    float: right;
    display: inline-block;
    height: 100%;
    line-height: 28px;
    font-size: 14px;
    color: #194485;
    letter-spacing: 1px;
    text-align: left;
}
.main-content-header .news-list .news-li {
    display: block;
    padding: 10px 5px;
    border-top: 1px solid #e9e9e9;
    line-height: 20px;
}
.main-content-header .news-list .news-li span {
    display: block;
}
.main-content-header .news-list .news-li i {
    width: 18px;
    max-height: 18px;
}
.main-content-header .news-list .news-li .news-li-title {
    margin-bottom: 10px;
    font-size: 18px;
    color: #1f1f1f;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    letter-spacing: 0;
    text-align: left;
}
.main-content-header .news-list .news-li .news-li-content {
    max-height: 44px;
    margin: 8px 0;
    overflow: hidden;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    line-height: 22px;
    text-align: justify;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
}
.main-content-header .news-list .news-li .news-li-operate {
    display: inline-block;
    margin-right: 10px;
    font-size: 12px;
    line-height: 18px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    vertical-align: middle;
}
.module-content .content-box {
    float: left;
    width: 330px;
    height: 330px;
    padding: 5px;
    margin: 0 25px 10px;
    overflow: hidden;
}
.module-content .content-title {
    width: 100%;
    border-bottom: 2px solid #999999;
}
.module-content .content-title .content-title-text {
    float: left;
    display: inline-block;
    width: auto;
    max-width: 130px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 0 5px;
    margin: 0;
    font-size: 16px;
    color: #999999;
    letter-spacing: 0;
    text-align: left;
    line-height: 46px;
    cursor: pointer;
    margin-right: 15px;
}
.module-content .content-title .content-title-active {
    margin-bottom: -2px;
    color: #194485;
    border-bottom: 3px solid #194485;
    line-height: 45px;
}
.module-content .content-title .content-title-active a {
    color: #194485;
}
.module-content .content-title .content-title-more {
    float: right;
    display: inline-block;
    height: 100%;
    line-height: 46px;
    font-size: 14px;
    color: #194485;
    letter-spacing: 1px;
    text-align: left;
}
.module-content .content-headline {
    width: 100%;
    margin: 15px 0;
}
.module-content .content-headline .content-img {
    float: left;
    display: inline-block;
    width: 122px;
    height: 100px;
    overflow: hidden;
}
.module-content .content-headline .content-img-title {
    float: right;
    width: 190px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    color: #232323;
    letter-spacing: 0;
    text-align: left;
}
.module-content .content-headline .content-img-desc {
    float: right;
    width: 190px;
    margin-top: 16px;
    font-size: 12px;
    color: #666666;
    letter-spacing: 0;
    line-height: 20px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 60px;
}
.module-content .content-ul {
    width: 100%;
    height: auto;
}
.module-content .content-ul .content-li {
    margin: 13px 0;
    width: 100%;
    line-height: 16px;
}
.module-content .content-ul .content-li .content-li-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 2.5px;
    background-color: #194485;
    font-size: 12px;
    color: #ffffff;
    text-align: center;
}
.module-content .content-ul .content-li .icon-dark {
    background-color: #999999;
}
.module-content .content-ul .content-li .content-li-text {
    max-width: 250px;
    display: inline-block;
    margin-left: 5px;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 16px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
}
.module-content .content-ul .content-li .content-li-before {
    display: inline-block;
    width: 6px;
    height: 6px;
    background-color: #194485;
    border-radius: 6px;
    vertical-align: middle;
}
.module-content .content-ul .content-li-secondary {
    float: left;
    width: 290px;
    height: 16px;
}
</style>



// WEBPACK FOOTER //
// src/view/resources/index.vue